import React, {Component} from 'react'
import {Button, Header, Modal} from 'semantic-ui-react'

export default class UnregisterRegularPlayerModal extends Component {

    state = {};

    handleClick = (ev, data) => this.setState({chosenPlayer: data.player});

    handleSubmit = () => this.props.unregisterRegularPlayer(this.state.chosenPlayer.id);

    render() {
        const playerOptions = this.props.players
            .map(player =>
                <Button
                    key={player.id}
                    onClick={this.handleClick}
                    player={player}
                    inverted color='red'
                    content={player.name}/>);

        return (
            <Modal
                open={this.props.open}
                basic
                size='small'
                closeOnEscape={true}
                closeOnDimmerClick={true}
            >
                <Header icon='users' content='Hvem skal avregistreres?'/>
                <Modal.Content>
                    {playerOptions}
                </Modal.Content>
                {this.state.chosenPlayer ?
                    <Modal.Actions>
                        Avregistrere {this.state.chosenPlayer.name}?
                        {<Button inverted onClick={this.handleSubmit} color='green' content='Stemmer'/>}
                    </Modal.Actions>
                    : <Modal.Actions>
                        Hvem skal avregistreres?
                    </Modal.Actions>}
            </Modal>)
    }
}



// WEBPACK FOOTER //
// ./src/Components/UnregisterRegularPlayerModal.js